import { QueryClient } from "@tanstack/react-query";

// Single QueryClient for the whole app. Tuning notes:
//
//   staleTime: 30 s   — within 30 s, navigating back to a page renders the
//                       cached data instantly with no network call.
//   gcTime:    5 min  — keep data in memory after a query goes unused, so
//                       coming back later still skips the loading flash.
//   refetchOnWindowFocus — refetch when the user tabs back to the app, so
//                          stale data does not linger on a long-open tab.
//
// Per-query overrides (e.g. very fresh polling for live incidents, or
// long staleTime for slow-moving settings) belong on the individual
// useQuery call, not here.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        // Don't retry on auth/permission/not-found errors — they won't fix
        // themselves with another request.
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
